import * as http from '../utils/request'
import { getLoginData, getRoleIds } from '@/utils/auth'


export function  loadAll() {
  return http.get("/role/loadAll");
}
export function queryList(params) {
  return http.get('/role/findPage', { ...params })
}

export function insert({name,description}) {
  return http.postJSON('/role/insert', {name,description})
}

export function update({id,name,description}) {
  return http.postJSON('/role/update', {id,name,description})
}



export function insertMenu(params) {
  return http.postJSON("/role/insertMenu",params)
}

export function findRoleMenu(roleId) {
   return http.get("/role/findRoleMenu",{roleId})
}
export function deleteRole(roleId) {
  return http.get("/role/delete",{id:roleId})
}


export async function getMenuByListID () {

  const response=  await http.get("/role/getMenuByListID");
  if(response && response.data){
    return response.data;
  }

}
